<template>
  <div class="ticket-center-body">
    <div v-if="ticketStore.isTicketSelected === false">
      <TicketMessagePlaceholder />
    </div>

    <div v-else class="ticket-center-body-layout">
      <!--      <template v-if="!ticketStore.loading.isFetchingMessage">-->
      <div class="ticket-center-header">
        <TicketMessageHeader
          :header="ticketStore.getSelectedTicketDetailHeader"
          @delete="
            showDeleteConfirmModal(
              ticketStore.getSelectedTicketDetailHeader.title
            )
          "
        />
      </div>

      <div class="ticket-center-main">
        <div
          :class="
            ticketStore.isRichText
              ? 'message-list__rich-text'
              : 'message-list__normal-text'
          "
          :style="[
            !ticketStore.loading.isFetchingMessage
              ? { 'justify-content': 'end' }
              : { 'justify-content': 'center' },
          ]"
          @scroll="onScrollToTop"
        >
          <div
            v-if="!ticketStore.loading.isFetchingMessage"
            class="message-container"
          >
            <div ref="scrollToRef" />
            <div
              v-for="(message, index) in ticketStore.getTicketMessages"
              :key="index"
              class="message-item"
            >
              <template v-if="message.participant">
                <template
                  v-if="message.participant.participantType === 'operator'"
                >
                  <OperatorMessageBox :message="message" />
                </template>
                <template
                  v-else-if="message.participant.participantType === 'customer'"
                >
                  <VisitorMessageBox :message="message" />
                </template>
                <template
                  v-else-if="message.participant.participantType === 'system'"
                >
                  <div>
                    <SystemMessageBox :message="message" />
                  </div>
                </template>
              </template>
              <template v-else>
                <UndefinedMessageBox :message="message" />
              </template>

              <!--              <VisitorMessageBox />-->
            </div>
          </div>

          <div v-else class="text-center loading-container">
            <b-spinner
              v-if="true"
              style="width: 4rem; height: 4rem"
              variant="primary"
              label="Spinning"
            />
          </div>
        </div>
      </div>

      <div class="ticket-center-footer">
        <TicketMessageInput
          :operation-name="`${userData.firstName} ${userData.lastName}`"
          :loading="ticketStore.getLoadingState"
          :internal-switch="ticketStore.getSelectedTicketDetail.internalNote"
          @submit="handleSubmit"
          @internalSwitchChange="handleUpdate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BModal, BSpinner } from "bootstrap-vue";
import TicketMessagePlaceholder from "@/views/ticket/ticketPlaceholder/ticketMessagePlaceholder.vue";
import TicketMessageHeader from "@/views/ticket/ticketCenterBody/ticketMessageHeader.vue";
import TicketMessageInput from "@/views/ticket/ticketCenterBody/ticketMessageInput.vue";
import TicketMessageList from "@/views/ticket/ticketCenterBody/ticketMessageList.vue";
import useTicketStore from "@/store-pinia/useTicketStore";
import VisitorMessageBox from "@/views/ticket/ticketCenterBody/ticketMessageBox/VisitorMessageBox.vue";
import OperatorMessageBox from "@/views/ticket/ticketCenterBody/ticketMessageBox/OperatorMessageBox.vue";
import SystemMessageBox from "@/views/ticket/ticketCenterBody/ticketMessageBox/SystemMessageBox.vue";
import UndefinedMessageBox from "@/views/ticket/ticketCenterBody/ticketMessageBox/UndefinedMessageBox.vue";
import { nextTick, ref } from "@vue/composition-api";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    UndefinedMessageBox,
    SystemMessageBox,
    OperatorMessageBox,
    VisitorMessageBox,
    BModal,
    BSpinner,
    TicketMessageList,
    TicketMessageInput,
    TicketMessageHeader,
    TicketMessagePlaceholder,
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
            localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName)
          );
    },
  },
  mounted() {
    this.scrollToElement("auto");
  },
  // methods: {
  //   scrollToElement(type = 'auto') {
  //     const el = this.$refs.scrollToElement
  //     if (el) {
  //       el.scrollIntoView({ behavior: type })
  //     }
  //   },
  // },
  setup() {
    const ticketStore = useTicketStore();
    const scrollToRef = ref(null);
    const scrollContainer = ref(null);

    function scrollToElement(type = "auto") {
      if (scrollToRef.value) {
        scrollToRef.value.scrollIntoView({ behavior: type });
        scrollToRef.value.scrollTop = scrollToRef.value.scrollHeight;
      }
    }

    function handleSubmit(valueToSubmit) {
      ticketStore.createTicketMessageAsync(valueToSubmit);
      nextTick(() => {
        scrollToElement("smooth");
      });
    }

    function handleUpdate(valueToUpdate) {
      ticketStore.updateTicketAsync({ internalNote: valueToUpdate });
    }

    function loadingDelete() {
      this.$bvModal.msgBoxConfirm("Please wait", {
        centered: true,
        title: "Deleting...",
      });
    }

    function showDeleteConfirmModal(title) {
      const shortcutTitle =
        title.length < 20 ? title : `${title.substring(0, 20)}...`;
      this.$bvModal
        .msgBoxConfirm(
          this.$t("alert.unableToRevertAfterDelete", {
            item: `${this.$t("ticket.ticket")} ${shortcutTitle}`,
          }),
          {
            centered: true,
            title: this.$t("field.delete"),
            okTitle: this.$t("alert.confirm"),
            cancelTitle: this.$t("ticket.cancel"),
          }
        )
        .then((value) => {
          // If Click Confirm
          if (value) ticketStore.deleteTicketAsync();
        })
        .catch((err) => {
          // An error occurred
        });
    }

    function onScrollToTop({
      target: { scrollTop, clientHeight, scrollHeight },
    }) {
      // console.log('scrollTop', scrollTop)
      // console.log('clientHeight', clientHeight)
      // console.log('scrollHeight', scrollHeight)
      // console.log('current', scrollTop * -1 + clientHeight + (scrollHeight * 25) / 100)
      // console.log('height', scrollHeight)

      const updateScrollOffSet = 10;
      if (
        scrollTop * -1 +
          clientHeight +
          (scrollHeight * updateScrollOffSet) / 100 >=
        scrollHeight
      ) {
        console.log("Scroll Reach top");
        console.log("ticketMessages", ticketStore.ticketMessages.length);
        console.log("ticketMessagesTotal", ticketStore.ticketMessagesTotal);
        if (
          ticketStore.ticketMessages.length < ticketStore.ticketMessagesTotal
        ) {
          console.log("get data");
          ticketStore.getTicketMessageInfiniteAsync();
        }
      }
    }

    return {
      ticketStore,
      scrollContainer,
      scrollToRef,
      onScrollToTop,
      handleSubmit,
      handleUpdate,
      showDeleteConfirmModal,
      scrollToElement,
    };
  },
};
</script>

<style lang="scss" scoped>
.ticket-center-body {
  .ticket-center-body-layout {
    position: relative;
    display: flex;

    flex-direction: column;

    .ticket-center-header {
      background: white;
    }

    .ticket-center-main {
      background: #f2f0f7;
      //padding-bottom: 2em;
    }

    .ticket-center-footer {
      background: white;
      position: sticky;
      bottom: 0;
      width: 100%;
    }
  }
}

.placeholder-container {
  background: #f2f0f7;

  .loading-container {
    height: calc(100vh - 300px);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.message-list {
  overflow-y: scroll;
  overflow-x: hidden;
  display: flex;
  flex-direction: column-reverse;
}

.message-container {
  margin-top: 1em;
  padding-left: 1em;
  padding-right: 1em;
  padding-bottom: 1em;
  display: flex;
  flex-direction: column-reverse;
  gap: 1em;
}

.message-list__normal-text {
  @extend .message-list;
  height: calc(100vh - 356px);
}

.message-list__rich-text {
  @extend .message-list;
  height: calc(100vh - 521px);
  //height: calc(100vh - 556px);
  @media screen and (max-width: 1318px) {
    height: calc(100vh - 555px);
    //background: ;
  }
}

.message-container .message-item:first-child {
  background: #00cfe8;
}

.fade-animation {
  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  animation-name: fade-in;
  animation-delay: 1s;
  animation-duration: 3s;
}
</style>
